import Reveal from "../components/Reveal";
import useCountUp from "../hooks/useCountUp";
import { STATS, IMAGES } from "../data/content";

function StatItem({ value, suffix, label, delay }) {
  const { ref, value: current } = useCountUp(value, 2200);
  return (
    <Reveal delay={delay} className="text-center">
      <div ref={ref} className="font-playfair text-5xl font-bold gold-gradient-text sm:text-6xl lg:text-7xl">
        {current}
        {suffix}
      </div>
      <p className="mt-3 text-xs uppercase tracking-[0.25em] text-neutral-400">{label}</p>
    </Reveal>
  );
}

export default function Stats() {
  return (
    <section data-testid="stats-section" className="relative overflow-hidden py-24 md:py-28">
      <div className="absolute inset-0">
        <img src={IMAGES.heroAlt} alt="" className="h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-[#050505]/85" />
      </div>
      <div className="container-x relative z-10">
        <div className="grid grid-cols-2 gap-10 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <StatItem key={s.label} {...s} delay={i * 0.1} />
          ))}
        </div>
      </div>
    </section>
  );
}
